var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserBlockGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3086 17.2532C20.373 15.7749 21 13.9607 21 12C21 7.02944 16.9706 3 12 3C9.43126 3 7.11387 4.07615 5.47408 5.8022L19.3086 17.2532ZM17.9663 18.7383C16.3781 20.1456 14.2888 21 12 21C7.02944 21 3 16.9706 3 12C3 10.3181 3.46136 8.74394 4.26443 7.39719L17.9663 18.7383Z",
    fill: "url(#paint0_linear_3301_81549)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3301_81549",
    x1: 3,
    y1: 12.0006,
    x2: 21,
    y2: 12.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlockGold);
export default __webpack_public_path__ + "static/media/User_Block_Gold.1f33c89f6da69cea9c30b802c9e71ee2.svg";
export { ForwardRef as ReactComponent };